import React from 'react';
import { Plus, Edit, Trash2, Search, UserCheck } from 'lucide-react';
import { useCrud } from '../hooks';
import { responsavelCaravanaService } from '../services/api';

const ResponsaveisCaravana = () => {
  const { data: responsaveis, loading, error } = useCrud(responsavelCaravanaService, 'responsáveis de caravana');
  const [searchTerm, setSearchTerm] = React.useState('');

  const filteredResponsaveis = responsaveis.filter(resp =>
    resp.nome?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  if (loading) {
    return <div className="loading"><div className="spinner"></div></div>;
  }

  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold">Responsáveis de Caravana</h1>
        <button className="btn btn-primary">
          <Plus size={20} />
          Novo Responsável
        </button>
      </div>

      {error && (
        <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded mb-4">
          {error}
        </div>
      )}

      <div className="card mb-6">
        <div className="flex items-center gap-4">
          <div className="relative flex-1">
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={20} />
            <input
              type="text"
              placeholder="Buscar responsáveis..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="form-input pl-10"
            />
          </div>
        </div>
      </div>

      <div className="card">
        {filteredResponsaveis.length === 0 ? (
          <div className="empty-state">
            <UserCheck className="empty-state-icon" />
            <h3 className="text-lg font-medium mb-2">Nenhum responsável encontrado</h3>
            <p className="mb-4">Em desenvolvimento - CRUD completo em breve.</p>
          </div>
        ) : (
          <div className="table-container">
            <table className="table">
              <thead>
                <tr>
                  <th>Nome</th>
                  <th>CPF</th>
                  <th>Telefone</th>
                  <th>Email</th>
                  <th>Ações</th>
                </tr>
              </thead>
              <tbody>
                {filteredResponsaveis.map((responsavel) => (
                  <tr key={responsavel.id}>
                    <td className="font-medium">{responsavel.nome}</td>
                    <td>{responsavel.cpf || '-'}</td>
                    <td>{responsavel.telefone || '-'}</td>
                    <td>{responsavel.email || '-'}</td>
                    <td>
                      <div className="flex gap-2">
                        <button className="btn btn-sm btn-secondary" title="Editar">
                          <Edit size={16} />
                        </button>
                        <button className="btn btn-sm btn-danger" title="Excluir">
                          <Trash2 size={16} />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default ResponsaveisCaravana;